<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h4">알람 전송 결과</div>
      </div>
      <div>
        <el-date-picker style="width: 250px;" v-model="dateRange" type="daterange" @change="onChangeTable" align="right" unlink-panels :range-separator="defaultDateRangeOptions.rangeSeparator"
          :start-placeholder="defaultDateRangeOptions.startPlaceholder" :end-placeholder="defaultDateRangeOptions.endPlaceholder" :picker-options="defaultDateRangeOptions.pickerOptions"
          :default-time="defaultDateRangeOptions.defaultTime"></el-date-picker>
        <w-header-search-button size="mini" @click="setSearchToolVisible"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper :column-default="columnDefault" @condition-change="onChangeTable" :total="total" remote
      class="alarm-table" :data="tableData" :columns="tableColumn" pagination :show-search-tool="showSearchTool" ref="alarmTable"
      style="width:100%;" :show-custom-header="true">
    </el-table-wrapper>
  </div>
</template>

<script>
import { columnDefault } from '@/constants/table';
import OperationSettingsAPI from '@/api/settings/common/operation-settings';
import { EMPTY_TEXT } from '@/utils/string';
import { defaultDateRangeOptions, getDateToString } from '@/utils/date';
import { isNil } from 'lodash';
import moment from 'moment';

export default {
  name: 'WAlarmResult',
  data() {
    const startDatetime = moment()
      .subtract(3, 'month') // 디폴트가 오늘이라면 해당코드 생략
      .startOf('day')
      .toDate();
    const endDatetime = moment()
      .endOf('day')
      .toDate();
    return {
      total: null,
      columnDefault,
      defaultDateRangeOptions,
      dateRange: [startDatetime, endDatetime],
      showSearchTool: false,
      tableColumn: [
        {
          prop: 'alarmtypeId',
          label: '전송구분',
          sortable: true,
          searchable: true,
          width: 100,
        },
        {
          prop: 'senderId',
          label: '전송자',
          width: 100,
          sortable: true,
          searchable: true,
        },
        {
          prop: 'receiverId',
          label: '수신자',
          sortable: true,
          searchable: true,
          width: 100,
        },
        {
          prop: 'alarmMessage',
          label: '내용',
          sortable: true,
          searchable: true,
          formatter: this.getEmptyText,
        },
        {
          prop: 'alarmResultStatus',
          label: '전송결과',
          width: 90,
          sortable: true,
          formatter: this.alarmResultConvert,
          className: 'alarm-result',
        },
        {
          prop: 'alarmErrorMessage',
          label: '실패메시지',
          sortable: true,
          searchable: true,
          formatter: this.getEmptyText,
        },
        {
          prop: 'registDatetime',
          label: '전송시각',
          sortable: true,
          width: 150,
          formatter: this.getDateFormatter,
        },
        {
          prop: 'finishDatetime',
          label: '전송확인시간',
          sortable: true,
          width: 150,
          formatter: this.getDateFormatter,
        },
      ],
      tableData: [],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      const tableParams = this.$refs.alarmTable.getParameter();
      const params = {
        // checkSms: true,
        // checkEmail: true,
        // checkMessenger: true,
        ...tableParams,
        datetimeStart: this.dateRange[0].getTime(),
        datetimeEnd: this.dateRange[1].getTime(),
      };
      // api 호출
      OperationSettingsAPI.getManagerAlarmSendResultList(params).then((response) => {
        if (response.data.success) {
          this.tableData = response.data.data;
          this.total = response.data.total;
        }
      });
    },
    onChangeTable() {
      this.loadData();
    },
    setSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    getEmptyText(row, column, value) {
      if (!isNil(value)) {
        return value;
      }
      return EMPTY_TEXT;
    },
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
    alarmResultConvert(row, column, value) {
      if (value === 'S') {
        return '성공';
      } else if (value === 'I') {
        return '처리중';
      }
      return '실패';
    },
  },
};
</script>
<style>
.alarm-table .alarm-result {
  width: 100%;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/EventAlarmSettings/AlarmSettings/AlarmResult.vue